/**
 * Fuzzy search scoring - extracted from NavMegaMenu and extended
 * to support multi-field matching with source tracking.
 */

export type FuzzyMatchResult = {
  score: number;
  matchedField: string;
};

export function fuzzyMatch(text: string, query: string): number {
  const textLower = text.toLowerCase();
  const queryLower = query.toLowerCase();

  if (textLower === queryLower) return 100;
  if (textLower.startsWith(queryLower)) return 90;
  if (textLower.includes(queryLower)) return 70;

  let score = 0;
  let queryIdx = 0;
  let consecutive = 0;

  for (let i = 0; i < textLower.length && queryIdx < queryLower.length; i++) {
    if (textLower[i] === queryLower[queryIdx]) {
      score += 10 + consecutive * 5;
      consecutive++;
      queryIdx++;
    } else {
      consecutive = 0;
    }
  }

  return queryIdx === queryLower.length ? score : 0;
}

export function fuzzyMatchMultiField(
  candidates: { text: string; field: string }[],
  query: string,
): FuzzyMatchResult {
  let best: FuzzyMatchResult = { score: 0, matchedField: '' };

  for (const candidate of candidates) {
    if (!candidate.text) continue;
    const score = fuzzyMatch(candidate.text, query);
    if (score > best.score) {
      best = { score, matchedField: candidate.field };
    }
  }

  return best;
}

export function fuzzyMatchArray(
  texts: string[],
  query: string,
): number {
  let best = 0;
  for (const text of texts) {
    if (!text) continue;
    const score = fuzzyMatch(text, query);
    if (score > best) best = score;
  }
  return best;
}
